// Components
import {
  AbsencePeriods,
  Accountant,
  AccountAuthorizationPerson,
  AccountAvatarEdit,
  AccountAvatarEditPerson,
  AccountContactEdit,
  AccountContactEditPerson,
  AccountDetailsEditPerson,
  AccountDetailsPerson,
  AccountInfo,
  AccountInfoPerson,
  AccountingReportList,
  AccountingReportQuery,
  AccountingHolidayPayDebtReportQuery,
  AccountingReportRows,
  AccountingReportTools,
  AccountingReportViewer,
  AccountingRowReport,
  AccountingSettings,
  AccountingTargetDetails,
  AccountingTargetSettings,
  AccountInsuranceEditPerson,
  AccountReset,
  ActionButton,
  Alert,
  AssurePartner,
  AuthCard,
  AuthorizedAccounts,
  AuthorizingAccounts,
  Avatar,
  Calc,
  CalcChart,
  CalcCostAccounting,
  CalcDashboard,
  CalendarEventDetails,
  CalcEmployment,
  CalcEditor,
  CalcHouseholdUsecase,
  CalcImport,
  CalcIrRows,
  CalcsIrRows,
  CalcList,
  CalcNewIntro,
  CalcRepair,
  CalcRepairInfo,
  CalcReport,
  CalcReports,
  CalcResults,
  CalcRowCostAccounting,
  CalcRowDimensionInput,
  CalcRowDocumentation,
  CalcRowFormula,
  CalcRowsEditor,
  CalcRows2019Editor,
  CalcRowType,
  CalcSharing,
  CalcSharingInfo,
  CalcSharingReceiptAction,
  CalcLeaves,
  CalculationReport,
  CalcUsecase,
  CalcWorkerInfo,
  CalcWorktime,
  Calendar,
  Certificates,
  Chart,
  CompanyImport,
  CompanyInvoices,
  ContactInfo,
  CostAccounting,
  CostAccountingSettings,
  HolidaySettings,
  Credentials,
  CreditTransfer,
  DataMapper,
  DatasetDetails,
  Datepicker,
  DatepickerPopup,
  DateRange,
  EmployerList,
  EmployerReport,
  EmployerSelect,
  EmploymentDetails,
  EmploymentTaxcards,
  ExpenseReport,
  FormGroup,
  HolidayPayReportQuery,
  HolidayReport,
  HolidayYearAccrual,
  HolidayYearHolidays,
  HolidayYearPaid,
  HourlyReport,
  HouseholdDeductionReport,
  HouseholdYearDetails,
  HouseholdYearList,
  ImportStaging,
  InputAccountingTarget,
  Input,
  InputBoolean,
  InputCollectiveBargainAgreement,
  InputCredential,
  InputDuration,
  InputEmployeeGroup,
  InputEnum,
  InputHolidayMultipliers,
  InputPayStatsRowType,
  InputIncomeType,
  InputMarkdown,
  InputNumber,
  InputOccupationType,
  InputRrule,
  InputTime,
  InputTypeahead,
  Insurance,
  InsuranceSettings,
  InvoiceAlerts,
  InvoiceEdit,
  InvoiceList,
  InvoicePreview,
  InvoicesCreate,
  InvoiceTools,
  InvoiceReport,
  InvoicePaymentList,
  IrDeliverySettings,
  IrEarningsPayment,
  IrPayerSummary,
  JsonFormatter,
  JsonDiff,
  LanguageSelector,
  LoginButton,
  MarkdownEditor,
  MarkdownViewer,
  MessageThread,
  MessageThreadList,
  NaviSitemap,
  NaviStarterLayout,
  OdataActions,
  OdataFooter,
  OdataTable,
  OwnerSettings,
  PayButton,
  PayCertificate,
  PaymentChannelInvoicePreview,
  PaymentChannelSettings,
  PaymentSettings,
  PayrollAssistant,
  PayrollDetails,
  PayrollDetailsList,
  PayrollDetailsSelectList,
  PayrollEdit,
  PayrollList,
  PayrollSelectList,
  PayStatsReportQuery,
  PayStatsSettings,
  ProSettings,
  Records,
  ReportList,
  RowTypesSettings,
  SalaryDateKindButton,
  SalaryReportList,
  ServiceModelDetails,
  Signing,
  SmokeTest,
  Spinner,
  SummaryReport,
  SummaryReportQuery,
  SxyAlert,
  SxyCodeEditor,
  SxyFieldset,
  SxyForm,
  SxyTable,
  SxyGrid,
  SxyInput,
  SxySchemaEditor,
  Tab,
  Tabs,
  TabButtons,
  TaxcardDetails,
  TaxcardIncomeLog,
  TaxcardManualEdit,
  TaxcardList,
  TaxCardsList,
  Textarea,
  ToggleButtons,
  Timer,
  UiTranslator,
  UsecaseDetails,
  UserInfo,
  ValidationSummary,
  VarmaBanner,
  Welcome,
  WorkerAbsences,
  WorkerAssure,
  WorkerDetails,
  WorkerHolidays,
  WorkerImport,
  EmploymentList,
  WorkerReport,
  WorkerSummaryReport,
  WorkflowButtons,
  WorkflowBadge,
  WorkflowReopen,
} from "./index_components";
import {
  IrEarningsPaymentList,
  IrPayerSummaryList
} from "./report";

/**
 * Provides the method for registering components to the module.
 */
export class ComponentsRegistration {

  /** Gets the components for Module registration. */
  public static getComponents() {
    return {
      // - account
      salaxyAccountInfo: new AccountInfo() as any,
      salaxyAssurePartner: new AssurePartner() as any,
      salaxyAuthCard: new AuthCard() as any,
      salaxyAuthorizedAccounts: new AuthorizedAccounts() as any,
      salaxyAuthorizingAccounts: new AuthorizingAccounts() as any,
      salaxyCertificates: new Certificates() as any,
      salaxyCredentials: new Credentials() as any,
      salaxyLanguageSelector: new LanguageSelector() as any,
      salaxyLoginButton: new LoginButton() as any,
      salaxySigning: new Signing() as any,
      salaxyUserInfo: new UserInfo() as any,
      salaxyAccountAvatarEdit: new AccountAvatarEdit() as any,
      salaxyAccountContactEdit: new AccountContactEdit() as any,

      // - personal
      salaxyAccountAuthorizationPerson: new AccountAuthorizationPerson() as any,
      salaxyAccountAvatarEditPerson: new AccountAvatarEditPerson() as any,
      salaxyAccountContactEditPerson: new AccountContactEditPerson() as any,
      salaxyAccountDetailsEditPerson: new AccountDetailsEditPerson() as any,
      salaxyAccountDetailsPerson: new AccountDetailsPerson() as any,
      salaxyAccountInfoPerson: new AccountInfoPerson() as any,
      salaxyAccountInsuranceEditPerson: new AccountInsuranceEditPerson() as any,
      salaxyEmployerList: new EmployerList() as any,
      salaxyEmployerSelect: new EmployerSelect() as any,

      // - calc
      salaxyCalcEmployment: new CalcEmployment() as any,
      salaxyCalcHouseholdUsecase: new CalcHouseholdUsecase() as any,
      salaxyCalcIrRows: new CalcIrRows() as any,
      salaxyCalcsIrRows: new CalcsIrRows() as any,
      salaxyCalcList: new CalcList() as any,
      salaxyCalcWorktime: new CalcWorktime() as any,
      salaxyCalc: new Calc() as any,
      salaxyCalcChart: new CalcChart() as any,
      salaxyCalcDashboard: new CalcDashboard() as any,
      salaxyCalcEditor: new CalcEditor() as any,
      salaxyCalcNewIntro: new CalcNewIntro() as any,
      salaxyCalcRepair: new CalcRepair() as any,
      salaxyCalcRepairInfo: new CalcRepairInfo() as any,
      salaxyCalcReport: new CalcReport() as any,
      salaxyCalcReports: new CalcReports() as any,
      salaxyCalcResults: new CalcResults() as any,
      salaxyCalcRowType: new CalcRowType() as any,
      salaxyCalcRowsEditor: new CalcRowsEditor() as any,
      salaxyCalcRows2019Editor: new CalcRows2019Editor() as any,
      salaxyCalcRowFormula: new CalcRowFormula() as any,
      salaxyCalcUsecase: new CalcUsecase() as any,
      salaxyPayrollDetails: new PayrollDetails() as any,
      salaxyPayrollDetailsList: new PayrollDetailsList() as any,
      salaxyPayrollDetailsSelectList: new PayrollDetailsSelectList() as any,
      salaxyPayrollEdit: new PayrollEdit() as any,
      salaxyPayrollList: new PayrollList() as any,
      salaxyPayrollAssistant: new PayrollAssistant() as any,
      salaxyPayButton: new PayButton() as any,
      salaxySalaryDateKindButton: new SalaryDateKindButton() as any,
      salaxyCalcSharing: new CalcSharing() as any,
      salaxyCalcSharingInfo: new CalcSharingInfo() as any,
      salaxyCalcSharingReceiptAction: new CalcSharingReceiptAction() as any,
      salaxyCalcLeaves: new CalcLeaves() as any,
      salaxyCalcWorkerInfo: new CalcWorkerInfo() as any,
      salaxyPayrollSelectList: new PayrollSelectList as any,
      salaxyCalcCostAccounting: new CalcCostAccounting as any,
      salaxyCalcRowCostAccounting: new CalcRowCostAccounting as any,
      salaxyCalcRowDimensionInput: new CalcRowDimensionInput as any,
      salaxyCalcRowDocumentation: new CalcRowDocumentation as any,
      salaxyCostAccounting: new CostAccounting as any,

      // - communications
      salaxyContactInfo: new ContactInfo() as any,
      salaxyHourlyReport: new HourlyReport() as any,
      salaxyMessageThread: new MessageThread() as any,
      salaxyMessageThreadList: new MessageThreadList() as any,
      salaxyTimer: new Timer() as any,
      salaxyVarmaBanner: new VarmaBanner() as any,
      salaxyWelcome: new Welcome() as any,
      salaxyExpenseReport: new ExpenseReport() as any,

      // - sxy-form framework
      sxyAlert: new SxyAlert() as any,
      sxyCodeEditor: new SxyCodeEditor() as any,
      sxyFieldset: new SxyFieldset() as any,
      sxyForm: new SxyForm() as any,
      sxyGrid: new SxyGrid() as any,
      sxyInput: new SxyInput() as any,
      sxySchemaEditor: new SxySchemaEditor() as any,

      // - sxy-table framework
      sxyTable: new SxyTable() as any,

      // - test: Test data and system testing.
      salaxyAccountReset: new AccountReset() as any,
      salaxySmokeTest: new SmokeTest() as any,

      // - form-controls
      salaxyDatepicker: new Datepicker() as any,
      salaxyDatepickerPopup: new DatepickerPopup() as any,
      salaxyDateRange: new DateRange() as any,
      salaxyFormGroup: new FormGroup() as any,
      salaxyInput: new Input() as any,
      salaxyInputAccountingTarget: new InputAccountingTarget() as any,
      salaxyInputBoolean: new InputBoolean() as any,
      salaxyInputCollectiveBargainAgreement: new InputCollectiveBargainAgreement() as any,
      salaxyInputCredential: new InputCredential() as any,
      salaxyInputDuration: new InputDuration() as any,
      salaxyInputEmployeeGroup: new InputEmployeeGroup() as any,
      salaxyInputEnum: new InputEnum() as any,
      salaxyInputIncomeType: new InputIncomeType() as any,
      salaxyInputMarkdown: new InputMarkdown() as any,
      salaxyMarkdownEditor: new MarkdownEditor() as any,
      salaxyMarkdownViewer: new MarkdownViewer() as any,
      salaxyInputNumber: new InputNumber() as any,
      salaxyInputOccupationType: new InputOccupationType() as any,
      salaxyInputRrule: new InputRrule() as any,
      salaxyInputTime: new InputTime() as any,
      salaxyInputTypeahead: new InputTypeahead() as any,
      salaxyToggleButtons: new ToggleButtons() as any,
      salaxyTextarea: new Textarea() as any,
      salaxyValidationSummary: new ValidationSummary() as any,
      salaxyInputHolidayMultipliers: new InputHolidayMultipliers() as any,
      salaxyInputPayStatsRowType: new InputPayStatsRowType() as any,

      // - helpers
      salaxyActionButton: new ActionButton() as any,
      salaxyAlert: new Alert() as any,
      salaxyAvatar: new Avatar() as any,
      salaxyChart: new Chart() as any,
      salaxyCalendar: new Calendar() as any,
      salaxyDataMapper: new DataMapper() as any,
      salaxyJsonFormatter: new JsonFormatter() as any,
      salaxyJsonDiff: new JsonDiff() as any,
      salaxyNaviSitemap: new NaviSitemap() as any,
      salaxyNaviStarterLayout: new NaviStarterLayout() as any,
      salaxyOdataActions: new OdataActions() as any,
      salaxyOdataFooter: new OdataFooter() as any,
      salaxyOdataTable: new OdataTable() as any,
      salaxySpinner: new Spinner() as any,
      salaxyTabs: new Tabs() as any,
      salaxyTab: new Tab() as any,
      salaxyTabButtons: new TabButtons() as any,
      salaxyUiTranslator: new UiTranslator() as any,

      // - import
      salaxyCalcImport: new CalcImport() as any,
      salaxyCompanyImport: new CompanyImport() as any,
      salaxyImportStaging: new ImportStaging() as any,
      salaxyWorkerImport: new WorkerImport as any,

      // - invoices
      salaxyCreditTransfer: new CreditTransfer() as any,
      salaxyInvoiceAlerts: new InvoiceAlerts() as any,
      salaxyInvoiceEdit: new InvoiceEdit() as any,
      salaxyInvoiceList: new InvoiceList() as any,
      salaxyInvoicePreview: new InvoicePreview() as any,
      salaxyInvoicesCreate: new InvoicesCreate() as any,
      salaxyPaymentChannelInvoicePreview: new PaymentChannelInvoicePreview() as any,
      salaxyInvoiceTools: new InvoiceTools() as any,
      salaxyInvoiceReport: new InvoiceReport() as any,
      salaxyInvoicePaymentList: new InvoicePaymentList() as any,
      salaxyCompanyInvoices: new CompanyInvoices,

      // - report
      salaxyHolidayReport: new HolidayReport() as any,
      salaxyHolidayPayReportQuery: new HolidayPayReportQuery() as any,
      salaxyIrEarningsPayment: new IrEarningsPayment() as any,
      salaxyIrEarningsPaymentList: new IrEarningsPaymentList() as any,
      salaxyIrPayerSummary: new IrPayerSummary() as any,
      salaxyIrPayerSummaryList: new IrPayerSummaryList() as any,
      salaxyReportList: new ReportList() as any,
      salaxySalaryReportList: new SalaryReportList() as any,
      salaxyAccountingReportQuery: new AccountingReportQuery() as any,
      salaxyAccountingHolidayPayDebtReportQuery: new AccountingHolidayPayDebtReportQuery() as any,
      salaxyAccountingReportList: new AccountingReportList() as any,
      salaxyAccountingReportRows: new AccountingReportRows() as any,
      salaxyAccountingReportTools: new AccountingReportTools() as any,
      salaxyAccountingReportViewer: new AccountingReportViewer() as any,
      salaxyPayCertificate: new PayCertificate() as any,
      salaxyCalculationReport: new CalculationReport() as any,
      salaxyAccountingRowReport: new AccountingRowReport() as any,
      salaxyEmployerReport: new EmployerReport() as any,
      salaxyWorkerReport: new WorkerReport() as any,
      salaxyHouseholdDeductionReport: new HouseholdDeductionReport() as any,
      salaxyHouseholdYearDetails: new HouseholdYearDetails() as any,
      salaxyHouseholdYearList: new HouseholdYearList() as any,
      salaxySummaryReport: new SummaryReport() as any,
      salaxySummaryReportQuery: new SummaryReportQuery() as any,
      salaxyWorkerSummaryReport: new WorkerSummaryReport() as any,
      salaxyPayStatsReportQuery: new PayStatsReportQuery() as any,

      // - worker
      salaxyAbsencePeriods: new AbsencePeriods() as any,
      salaxyEmploymentDetails: new EmploymentDetails(),
      salaxyEmploymentTaxcards: new EmploymentTaxcards() as any,
      salaxyHolidayYearAccrual: new HolidayYearAccrual() as any,
      salaxyHolidayYearHolidays: new HolidayYearHolidays() as any,
      salaxyHolidayYearPaid: new HolidayYearPaid() as any,
      salaxyTaxcardDetails: new TaxcardDetails() as any,
      salaxyTaxcardIncomeLog: new TaxcardIncomeLog() as any,
      salaxyTaxcardManualEdit: new TaxcardManualEdit() as any,
      salaxyTaxcardList: new TaxcardList() as any,
      salaxyTaxCardsList: new TaxCardsList() as any,
      salaxyWorkerAbsences: new WorkerAbsences() as any,
      salaxyWorkerDetails: new WorkerDetails() as any,
      salaxyWorkerHolidays: new WorkerHolidays() as any,
      salaxyEmploymentList: new EmploymentList() as any,
      salaxyWorkerList: new EmploymentList() as any, // For backward compatibility only

      // - obsolete
      salaxyWorkerAssure: new WorkerAssure() as any,

      // - workflow
      salaxyCalendarEventDetails: new CalendarEventDetails() as any,
      salaxyDatasetDetails: new DatasetDetails() as any,
      salaxyWorkflowButtons: new WorkflowButtons() as any,
      salaxyWorkflowReopen: new WorkflowReopen() as any,
      salaxyWorkflowBadge: new WorkflowBadge() as any,

      // - records
      salaxyRecords: new Records() as any,

      // - settings
      salaxyAccountant: new Accountant() as any,
      salaxyRowTypesSettings: new RowTypesSettings() as any,
      salaxyAccountingTargetDetails: new AccountingTargetDetails() as any,
      salaxyInsurance: new Insurance() as any,
      salaxyInsuranceSettings: new InsuranceSettings() as any,
      salaxyOwnerSettings: new OwnerSettings() as any,
      salaxyPaymentChannelSettings: new PaymentChannelSettings() as any,
      salaxyPaymentSettings: new PaymentSettings() as any,
      salaxyProSettings: new ProSettings() as any,
      salaxyAccountingTargetSettings: new   AccountingTargetSettings() as any,
      salaxyServiceModelDetails: new ServiceModelDetails() as any,
      salaxyUsecaseDetails: new UsecaseDetails() as any,
      salaxyCostAccountingSettings: new CostAccountingSettings() as any,
      salaxyAccountingSettings: new AccountingSettings() as any,
      salaxyHolidaySettings: new HolidaySettings() as any,
      salaxyPayStatsSettings: new PayStatsSettings() as any,
      salaxyIrDeliverySettings: new IrDeliverySettings() as any,
    };
  }
}
